import { createStore } from 'vuex'
import createMultiTabState from 'vuex-multi-tab-state'

export default createStore({
  state: {
    user: null,
    token: null,
    area: null,
    dni: null,
    uutt: null
  },
  mutations: {
    setUser (state, user) {
      state.user = user
    },
    setToken (state, token) {
      state.token = token
    },
    setDni (state, dni) {
      state.dni = dni
    },
    setArea (state, area) {
      state.area = area
    },
    setUutt (state, uutt) {
      state.uutt = uutt
    }
  },
  actions: {
  },
  modules: {
  },
  getters: {
    isLoggedIn (state) {
      return !!state.token
    },
    getToken (token) {
      return token
    },
    getDni (state) {
      return state.dni
    },
    getUutt (state) {
      return state.uutt
    },
    getArea (area) {
      return area
    },
    errorMsg (val) {
      this.$message({
        message: val,
        type: 'error'
      })
    }
  },
  plugins: [
    createMultiTabState()
  ]
})
